// src/pages/admin/EpisodeEditPage.js
import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import EpisodeForm from "./organisms/EpisodeForm";

const EpisodeEditPage = () => {
  const { id } = useParams();
  const [episodeData, setEpisodeData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEpisode = async () => {
      const episodeDocRef = doc(db, "episodes", id);
      const episodeDoc = await getDoc(episodeDocRef);
      if (episodeDoc.exists()) {
        setEpisodeData({ id: episodeDoc.id, ...episodeDoc.data() });
      } else {
        console.error("No such episode!");
      }
    };
    fetchEpisode();
  }, [id]);

  const handleUpdate = async (data) => {
    const episodeDocRef = doc(db, "episodes", id);
    await updateDoc(episodeDocRef, {
      ...data,
      updatedAt: serverTimestamp(),
    });
    alert("Episode updated successfully");
    navigate("/admin");
  };

  if (!episodeData) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Container maxWidth="md">
      <Typography variant="h4" sx={{ my: 2 }}>
        Episode Management
      </Typography>
      <EpisodeForm
        initialData={episodeData}
        onSubmit={handleUpdate}
        isEdit={true}
      />
    </Container>
  );
};

export default EpisodeEditPage;
